<template>
  <ul class="horizontal-menu">
    <li v-for="{ text, menuItem } in menuItems" :key="text" class="horizontal-menu-item">
      <button
        @click="$emit('onMenuItemChange', menuItem)"
        :class="[
          'horizontal-menu-button',
          {
            'horizontal-menu-button_active': activeMenuItem === menuItem,
          },
        ]"
      >
        {{ text }}
      </button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    menuItems: { type: Array, require: true },
    activeMenuItem: { type: String, require: true },
  },
};
</script>

<style scoped>
.horizontal-menu {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 32px;
  margin-top: 32px;
  padding: 8px 24px 0;
  border-bottom: 1px solid var(--border-color);
}
.horizontal-menu-button {
  position: relative;
  padding: 0;
  border: none;
  font-size: 14px;
  font-family: "Ubuntu", sans-serif;
  font-weight: 500;
  line-height: 16px;
  color: var(--grey-3-color);
  background-color: transparent;
  padding-bottom: 8px;
  transition: color 0.15s ease-out;
}
.horizontal-menu-button_active {
  color: var(--primary-color);
}
.horizontal-menu-button_active::after {
  position: absolute;
  content: "";
  width: 100%;
  height: 1px;
  background-color: var(--primary-color);
  left: 0;
  bottom: -1px;
}
.horizontal-menu-button:hover {
  color: var(--primary-hover-color);
}
</style>
